module.exports = __webpack_public_path__ + "static/img/mouse_wait.8411ef0d.gif";